import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const formSx: SxProps<Theme> = {
    display: 'grid',
    gridTemplateColumns: 'auto',
    gap: theme.spacing(20 / 8),
    py: theme.spacing(20 / 8),
    [theme.breakpoints.down('md')]: {
        padding: 0,
        gap: theme.spacing(10 / 8),
    },
};

export const submitButtonSx: SxProps<Theme> = {
    maxWidth: theme.spacing(175 / 8),
    alignSelf: 'flex-end',
    '& span': {
        textTransform: 'none',
    },
};

export const actionsWrapperSx: SxProps<Theme> = {
    padding: theme.spacing(20 / 8, 24 / 8),
    borderTop: `${theme.spacing(1 / 8)} solid ${theme.palette.neutral[200]}`,
    background: theme.palette.neutral[50],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(20 / 8),
    [theme.breakpoints.down('md')]: {
        background: 'transparent',
        border: 'none',
        flexDirection: 'column',
        gap: theme.spacing(20 / 8),
        padding: theme.spacing(10 / 8, 0, 20 / 8),
        '& .MuiButton-root': {
            width: '100%',
            alignSelf: 'center',
            maxWidth: 'none',
        },
    },
};

export const requiredFieldSx: SxProps<Theme> = {
    '& span': {
        marginRight: theme.spacing(5 / 8),
        color: theme.palette.warning.main,
    },
};
